import React, { useState, useEffect } from "react";
import { Column, Summary, TotalItem } from "devextreme-react/data-grid";
import { LVGridCarga } from "../../Componentes/Basicos/LVGridCarga";
import DateBox from 'devextreme-react/date-box';
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import ComboConPlantillaOperacionesParaImportar from "../../Componentes/Compuestos/Combos/ComboConPlantillaOperacionesParaImportar";
import { NumberBox, SelectBox, TextBox } from "devextreme-react";
import ComboAbmEexProveedores from "../../Componentes/Compuestos/Combos/ComboAbmEexProveedores";
import ComboAbmEexProfesionales from "../../Componentes/Compuestos/Combos/ComboAbmEexProfesionales";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import { function_CON_Cheques_Acreditar, function_CON_Cheques_Generar_JSON, function_CON_Cheques_Insertar } from "neftis7_apicaller/src/funciones/CONT/CON_Cheques";
import { function_CON_OperacionesParaImportar_Generar_JSON, function_CON_OperacionesParaImportar_Insertar } from "neftis7_apicaller/src/funciones/CONT/CON_OperacionesParaImportar";
import { function_VerificacionDeCompaniaAutorizada } from "../../funciones/Varios";
import { useNavigate } from "react-router-dom";
import { FormateoFechaPara_ddMMyyyy, FormateoFechaPara_yyyyMMdd } from "neftis7_apicaller/src/funciones/Varios";
import { function_ABM_CON_CuentasFinancieras_LeerSaldo } from "neftis7_apicaller/src/funciones/ABM/CONT/ABM_CON_CuentasFinancieras";
import { function_CON_Transferencias_Generar_JSON, function_CON_Transferencias_Insertar } from "neftis7_apicaller/src/funciones/CONT/CON_Transferencias";

export const CON_OperacionesParaImportar_Plantilla = () => {
  const [data, setData] = useState([]);
  const [dataCheques, setDataCheques] = useState([]);
  const [idPlantilla, setIdPlantilla] = useState(0);
  const [IdProfesional, setIdProfesional] = useState(0);
  const [codigoCuentaFinancieraAsociada, setCodigoCuentaFinancieraAsociada] = useState("");
  const [codigoCuentaFinancieraRendicion, setCodigoCuentaFinancieraRendicion] = useState("");
  const [saldoCuentaFinancieraAsociada, setSaldoCuentaFinancieraAsociada] = useState("");
  const [configuracion, setConfiguracion] = useState({});
  const [reparto, setReparto] = useState(null);
  const [deberiaRendir, setDeberiaRendir] = useState(0);
  const [deberiaRendirCheques, setDeberiaRendirCheques] = useState(0);
  const [importeCheques, setImporteCheques] = useState(0);
  const [rinde, setRinde] = useState(0);
  const [fecha, setFecha] = useState(new Date());
  const [faltante, setFaltante] = useState(0);
  const [sobrante, setSobrante] = useState(0);
  const navigate = useNavigate();
  const [cierreEnProceso, setCierreEnProceso] = useState(false);

  const { CON_Plantilla_OperacionesParaImportar_Cabecera: { function_CON_Plantilla_OperacionesParaImportar_Cabecera_Leer } } = require('neftis7_apicaller');

  const handleOnClickGuardar = async () => {
    if (importeCheques !== deberiaRendirCheques) {
      alert("El importe de Cheques ($" + importeCheques + ") debe ser el mismo que el importe recibido en Cheques ($" + deberiaRendirCheques + ")")
      return
    }

    const confirmar = window.confirm("¿Estás seguro de que deseas guardar?");

    if (!confirmar) {
      return;
    }

    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);
      
      // Procesar cheques
      for (const cheque of dataCheques) {
        const JSON = await function_CON_Cheques_Generar_JSON(localStorage.getItem("CodigoCompania"), null, null, null, null, cheque.Numero, FormateoFechaPara_yyyyMMdd(fecha),
          FormateoFechaPara_yyyyMMdd(cheque.FechaCompromiso), null, null, null, cheque.Banco, cheque.Importe, 1110, 0, 0, null, null, null, null, null,
          'INGRESO DE PLANTILLA Nº' + idPlantilla, null, null, null)

        await function_CON_Cheques_Insertar(JSON);
      }

      // Procesar operaciones
      for (const operacion of data) {
        if (operacion.ImporteNeto > 0) {
          const operacionJSON = await function_CON_OperacionesParaImportar_Generar_JSON(
            FormateoFechaPara_yyyyMMdd(fecha),
            operacion.Descripcion,
            operacion.ImporteNeto,
            operacion.IdTipoOperacion,
            1, // Cantidad
            operacion.CodigoArticulo || "",
            operacion.CodigoPresentacion || "DEF",
            operacion.CodigoTamano || "DEF",
            operacion.CodigoUnidadMedida || "UN",
            "", // CodigoUbicacionIngreso
            operacion.CodigoSubCC,
            operacion.CodigoCuentaFinanciera,
            1, // Cuotas
            0, // IdOperacion1
            0, // IdOperacion2
            operacion.IdCliente,
            operacion.IdProveedor,
            localStorage.getItem("IdPersona"),
            "PA", // CodigoMoneda
            1, // Cotizacion
            operacion.Factura || "",
            operacion.IdTipoDocumento,
            operacion.ImportePercepciones || 0,
            operacion.ImporteIVA10 || 0,
            operacion.ImporteIVA21 || 0,
            operacion.ImporteIVA27 || 0,
            operacion.ImportePercepcionGanancias || 0,
            operacion.ComprobantePercepcionIIBB || "",
            operacion.ComprobantePercepcionIVA || "",
            operacion.ComprobantePercepcionSUSS || "",
            operacion.ComprobantePercepcionGanancias || "",
            operacion.ComprobantePercepcionImpuestosInternos || "",
            operacion.ImporteRetencionIIBB || 0,
            operacion.ImporteRetencionIVA || 0,
            operacion.ImporteRetencionSUSS || 0,
            operacion.ImporteRetencionGanancias || 0,
            operacion.ImporteRetencionImpuestosInternos || 0,
            operacion.ComprobanteRetencionIIBB || "",
            operacion.ComprobanteRetencionIVA || "",
            operacion.ComprobanteRetencionSUSS || "",
            operacion.ComprobanteRetencionGanancias || "",
            operacion.ComprobanteRetencionImpuestosInternos || "",
            operacion.ImporteExento || 0,
            operacion.ImporteIVA10 || 0,
            operacion.ImporteIVA21 || 0,
            operacion.ImporteIVA27 || 0,
            "", // CodigoCuentaContableDocCompraVenta
            "", // CodigoCuentaContablePagoRecibo
            0, // NCPorcentaje
            0, // NCIdProveedor
            0, // Socio1Porcentaje
            0, // Socio1IdPersona
            0, // Socio2Porcentaje
            0, // Socio2IdPersona
            0, // Socio3Porcentaje
            0, // Socio3IdPersona
            0, // Socio4Porcentaje
            0, // Socio4IdPersona
            0, // NDPorcentaje
            0, // NDIdProveedor
            localStorage.getItem("CodigoPlanta")
          );

          await function_CON_OperacionesParaImportar_Insertar(operacionJSON);
        }
      }

      //Transferencia final
      if (codigoCuentaFinancieraAsociada && codigoCuentaFinancieraRendicion && codigoCuentaFinancieraAsociada != "" && codigoCuentaFinancieraRendicion != "") {
        const JSONTransferenciaFinal = await function_CON_Transferencias_Generar_JSON(FormateoFechaPara_yyyyMMdd(fecha), codigoCuentaFinancieraAsociada, codigoCuentaFinancieraRendicion, null, null, null, rinde, rinde, data.Descripcion, data.Descripcion, "", null, null, 1, 1)

        await function_CON_Transferencias_Insertar(JSONTransferenciaFinal)
      }

      alert("Datos guardados correctamente.");

      window.location.reload()
    } catch (error) {
      alert("Error al guardar los datos: " + error.message);
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  }

  const CalcularTotales = async () => {
    try {
      const totalImporteNeto = data.reduce((total, item) => {
        if (item.IdTipoOperacion === 4) {
          return total + (item.ImporteNeto || 0);
        } else if (item.IdTipoOperacion === 1) {
          return total - (item.ImporteNeto || 0);
        }
        return total;
      }, 0);
      setDeberiaRendir(totalImporteNeto);

      const totalImporteCheques = data.reduce((total, item) => {
        if (item.IdTipoOperacion === 4) {
          return total + (item.ImporteCheque || 0);
        } else if (item.IdTipoOperacion === 1) {
          return total - (item.ImporteCheque || 0);
        }
        return total;
      }, 0);
      setDeberiaRendirCheques(totalImporteCheques);
    } catch (error) {
      alert("Error al calcular totales: " + error.message);
    }
  }

  const CalcularCheques = async () => {
    try {
      const totalImporteNeto = dataCheques.reduce((total, item) => {
        return total + (item.Importe || 0);
      }, 0);
      setImporteCheques(totalImporteNeto);
    } catch (error) {
      alert("Error al calcular cheques: " + error.message);
    }
  }

  useEffect(() => {
    const diferencia = deberiaRendir - rinde;
    if (diferencia > 0) {
      setFaltante(diferencia);
      setSobrante(0);
    } else {
      setSobrante(Math.abs(diferencia));
      setFaltante(0);
    }
  }, [deberiaRendir, rinde]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (idPlantilla > 0) {
          const resultPlantilla = await function_CON_Plantilla_OperacionesParaImportar_Cabecera_Leer(idPlantilla);

          setData(resultPlantilla.data.Detalles);
          setConfiguracion(resultPlantilla.data);

          setCodigoCuentaFinancieraAsociada(resultPlantilla.data.CodigoCuentaFinancieraAsociada)
          setCodigoCuentaFinancieraRendicion(resultPlantilla.data.CodigoCuentaFinancieraRendicion)

          const resultCuentaFinanciera = await function_ABM_CON_CuentasFinancieras_LeerSaldo(resultPlantilla.data.CodigoCuentaFinancieraAsociada)
          setSaldoCuentaFinancieraAsociada(resultCuentaFinanciera.data[0].Saldo)
        }
      } catch (error) {
        alert(error);
      }
    };

    fetchData();
  }, [idPlantilla]);

  useEffect(() => {
    CalcularTotales()
  }, [data]);

  useEffect(() => {
    CalcularCheques()
  }, [dataCheques]);

  useEffect(() => {
    const functionAsinc = async () => {
      if (!await function_VerificacionDeCompaniaAutorizada()) {
        navigate("/Login");
      }
    };

    functionAsinc();
  }, []);

  return (
    <PaginaCarga
      Titulo="IMPORTADOR DE OPERACIONES POR PLANTILLA"
    >
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          FECHA
          <DateBox displayFormat="dd/MM/yyyy" width={120} value={fecha} onValueChanged={(e) => setFecha(e.value)} />
          <ComboConPlantillaOperacionesParaImportar value={idPlantilla} ancho="500" onValueChanged={(e) => {
            setIdPlantilla(e.value);
            setDeberiaRendir(0);
            setDeberiaRendirCheques(0);
            setImporteCheques(0);
            setData([])
            setDataCheques([])
          }} />

          {configuracion.MuestraProfesional && (
            <>
              AYUDANTE
              <ComboAbmEexProfesionales ancho="500" onValueChanged={(e) => setIdProfesional(e.value)} />
              HOJA DE RUTA
              <TextBox />
              SALDO CUENTA
              <NumberBox width={120} value={saldoCuentaFinancieraAsociada} readOnly={true} />
            </>
          )}
        </div>
        {data.length > 0 ? (
          <>
            <LVGridCarga
              dataSource={data}
              id="gridContainer"
              allowDeleting={false}
              onRowUpdated={() => { CalcularTotales() }}
            >

              <Column caption="Código" dataField="IdItem" width="120" alignment="Right" dataType="number" readOnly={true} visible={false} />
              <Column caption="Tipo Operación" dataField="IdTipoOperacion" width="120" alignment="Right" dataType="number" readOnly={true} visible={false} />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth={100} alignment="Left" dataType="string" readOnly={true} />
              <Column caption="Efectivo Neto" dataField="ImporteNeto" width="100" alignment="Left" dataType="number" />
              {configuracion.MuestraProfesional && (
                <Column caption="Cheques" dataField="ImporteCheque" width="150" alignment="Left" dataType="number" />
              )}


              {configuracion.MuestraImportesDetallados && (
                <Column caption="Importe IVA 10.5%" dataField="ImporteIVA105" width="140" alignment="Right" dataType="number" format="currency" />
              )}

              {configuracion.MuestraImportesDetallados && (
                <Column caption="Importe IVA 21%" dataField="ImporteIVA21" width="130" alignment="Right" dataType="number" format="currency" />
              )}

              {configuracion.MuestraFactura && (
                <Column caption="Factura" dataField="Factura" width="150" alignment="Left" dataType="string" />
              )}

              {configuracion.MuestraPercepciones && (
                <>
                  <Column caption="Comp. Percepciones" dataField="ComprobantePercepciones" width="150" alignment="Left" dataType="string" />
                  <Column caption="Importe Percepciones" dataField="ImportePercepciones" width="150" alignment="Right" dataType="number" format="currency" />
                </>
              )}

              {configuracion.MuestraRetenciones && (
                <>
                  <Column caption="Comp. Retenciones" dataField="ComprobanteRetenciones" width="150" alignment="Left" dataType="string" />
                  <Column caption="Importe Retenciones" dataField="ImporteRetenciones" width="150" alignment="Right" dataType="number" format="currency" />
                </>
              )}

              {configuracion.MuestraProveedor && (
                <Column caption="Proveedor" dataField="Proveedor" width="200" alignment="Left" cellRender={() => <ComboAbmEexProveedores />} />
              )}

              {configuracion.MuestraObservaciones && (
                <Column caption="Observaciones" dataField="Observaciones" width="250" alignment="Left" dataType="string" />
              )}

              <Summary>
                <TotalItem
                  column="Descripcion"
                  summaryType="count"
                  customizeText={summaryItem => `Registros: ${summaryItem.value}`} />
              </Summary>

            </LVGridCarga>

            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginTop: '20px' }}>
              {configuracion.MuestraProfesional && (
                <>
                  <span>Debería rendir</span>
                  <NumberBox width={120} value={deberiaRendir} readOnly={true} />
                  <span>Rinde</span>
                  <NumberBox width={120} value={rinde} onValueChanged={(e) => setRinde(parseFloat(e.value) || 0)} />
                  <span>Faltante</span>
                  <NumberBox width={120} value={faltante} readOnly={true} />
                  <span>Sobrante</span>
                  <NumberBox width={120} value={sobrante} readOnly={true} />
                </>
              )}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginTop: '40px' }}>

            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginTop: '20px' }}>
              {configuracion.MuestraProfesional && (
                <>
                  CHEQUES RECIBIDOS
                  <LVGridCarga
                    dataSource={dataCheques}
                    id="gridContainer"
                    allowAdding={true}
                    onRowUpdated={() => { CalcularCheques() }}
                    onRowRemoved={() => { CalcularCheques() }}
                    onRowInserted={() => { CalcularCheques() }}
                  >
                    <Column caption="Número" dataField="Numero" Width="100" minWidth={150} alignment="Left" dataType="string" />
                    <Column caption="Banco" dataField="Banco" width="100%" minWidth={100} alignment="Left" dataType="string" />
                    <Column caption="Importe Cheque" dataField="Importe" width="150" alignment="Left" dataType="number" />
                    <Column caption="Fecha Compromiso" dataField="FechaCompromiso" width="150" alignment="Left" dataType="date" format={'dd/MM/yyyy'} />

                    <Summary>
                      <TotalItem
                        column="Banco"
                        summaryType="count"
                        customizeText={summaryItem => `Registros: ${summaryItem.value}`} />
                    </Summary>

                  </LVGridCarga>
                </>
              )}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginTop: '40px' }}>

            </div>

            <LVButtonAccion
              Disabled={cierreEnProceso} Ancho={"100%"} Texto={"GUARDAR"} onClick={handleOnClickGuardar} />
          </>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaCarga>
  );
};
